import type { FeatureGroup } from '../../types';

export const TICKETS_FEATURE_GROUP: FeatureGroup = {
  guid: 'd9e4f7c2-3b58-4d71-9c36-7f1a2e4b0000',
  name: 'tickets',
  description: 'Root group for all tickets features — the tickets workspace',
  product: 'tickets',
};
